<template>
  <div :class="['home flex-column', programStyle]">
    <div class="title-container flex-row">
      <div class="flex-column">
        <span class="title">{{ $t('security-center') }}</span>
        <ul class="subtitle flex-row">
          <li @click="goToPrograms">{{ $t('programs') }}&nbsp;&gt;&nbsp;</li>
          <li @click="goToDealersList">{{ domain }}&nbsp;&gt;&nbsp;</li>
          <li @click="clearRequest">{{ $t('security-center') }}</li>
          <li v-if="pageType === 'add'">&nbsp;&gt;&nbsp;Submit Request</li>
          <li v-if="!showViewPage && pageType === 'edit'">&nbsp;&gt;&nbsp;Edit Request</li>
          <li v-if="showViewPage && pageType === 'edit'">&nbsp;&gt;&nbsp;View Request</li>
          <li v-if="pageType === 'review'">&nbsp;&gt;&nbsp;Review Request</li>
        </ul>
      </div>
      <div class="right" v-if="appliedFilters && !pageType">
        <FilterModal
          :appliedFiltersLength="appliedFilters.length"
          :valueMulti="activeFilters"
          @clear-filters="clearAllFilters"
          @updateMulti="updateMulti"
        />
        <div>
          <Magnifier class="search-icn"></Magnifier>
          <input
            class="search-input"
            :placeholder="$t('search')"
            v-model="search"
            type="text"
            v-debounce:1000ms="searchDebounce"
          />
        </div>
      </div>
    </div>
    <div class="content flex-column">
      <div class="requests-table" v-if="!pageType">
        <span class="requests-attention" v-if="reviewList && reviewList.length > 0">
          <img src="@/assets/new/warning_white.png" />
          {{ $t('review-banner-text', [reviewList.length]) }}
          <span class="attention" @click="setMultipleReview">{{ $t('review-request') }}</span></span
        >
        <div class="above-table flex-column">
          <div class="table-descriptors flex-row">
            <span>{{ $t('submitted-requests') }}</span>
            <button @click="pageType = 'add'">{{ $t('submit-new-request') }}</button>
          </div>
        </div>
        <div class="table-container flex-column">
          <DataTable :headings="fieldSecurityCenterTH" :rows="requests" :perPage="numPerPage" :page="currentPage">
            <template v-slot:viewSlot="slotProps">
              <Eyecon class="eyecon" @click="getSingleRequest(slotProps.row.id)"></Eyecon>
            </template>
            <template v-slot:deleteSlot="slotProps">
              <Cancel v-if="slotProps.row.isCancellable" class="delete-icon" @click="openModal(slotProps.row)"></Cancel>
            </template>
          </DataTable>
          <div v-if="requests.length === 0" class="empty-table-message">
            <span v-if="this.appliedFilters.length > 0">{{ $t('no-matches-filters') }}</span>
            <span v-else-if="search.length > 0">{{ $t('no-matches-search') }}</span>
            <span v-else
              >{{ $t('no-submitted-requests') }}
              <span class="attention" @click="pageType = 'add'">{{ $t('submitting-a-new-request') }}</span></span
            >
          </div>
          <div class="row-container">
            <div class="row-info">
              {{ $t('viewing-firstrow-lastrow-of-forms-totalcount', [firstRow, lastRow, totalCount]) }}
            </div>
            <GPagination
              v-if="pageCount > 1"
              class="pagination"
              v-model="page"
              :pageCount="pageCount"
              @changed="getRequests"
            />
          </div>
        </div>
      </div>
      <RoleRequests
        v-if="pageType"
        :selectedRequestArray="selectedRequestArray"
        :pageType="pageType"
        :reviewList="reviewList"
        :multipleReview="multipleReview"
        :showViewPage="showViewPage"
        @exit="clearRequest"
      />
    </div>
    <Modal class="modal-screens" v-show="isModalOpen">
      <template v-slot:body class="body">
        <p id="modal-title">{{ $t('cancel-submitted-request') }}</p>
        <p id="modal-message">{{ $t('cancel-request-warning') }}</p>
        <div class="modal-button-container">
          <button class="submit" @click="cancelRequest">{{ $t('yes') }}</button>
          <button @click="isModalOpen = false">{{ $t('no') }}</button>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import Eyecon from '@/assets/new/eye-con.svg';
import GPagination from '@/components/GComponents/GPagination.vue';
import Magnifier from '@/assets/icons/magnifier.svg';
import Cancel from '@/assets/new/icon_cancel.svg';
import { mapState } from 'vuex';
import fieldSecurityCenterTH from '@/utils/tableHeaders/fieldSecurityCenterTH';
import FilterModal from '@/components/FilterModal.vue';
import RoleRequests from '@/components/RoleRequests.vue';
import Modal from '@/components/Modal.vue';

const requestStatusFilterOptions = [
  {
    label: 'Active',
    checked: false,
  },
  {
    label: 'Cancelled',
    checked: false,
  },
  {
    label: 'Partial',
    checked: false,
  },
  {
    label: 'Approved',
    checked: false,
  },
  {
    label: 'Denied',
    checked: false,
  },
];

const requestActionFilterOptions = [
  {
    label: 'Add',
    checked: false,
  },
  {
    label: 'Revoke',
    checked: false,
  },
  {
    label: 'Change',
    checked: false,
  },
];

export default {
  name: 'Field-Security-Center',
  components: {
    DataTable,
    Eyecon,
    Cancel,
    GPagination,
    Magnifier,
    FilterModal,
    RoleRequests,
    Modal,
  },
  data() {
    return {
      requests: [],
      fieldSecurityCenterTH: fieldSecurityCenterTH(),
      page: 1,
      numPerPage: 10,
      currentPage: 1,
      totalCount: null,
      rowCountDropValue: { label: this.$t('show-10'), value: 10 },
      tempRow: null,
      isModalOpen: false,
      pageType: null,
      reviewList: null,
      search: '',
      typeFilter: [],
      actionFilter: [],
      statusFilter: [],
      appliedFilters: null,
      multiFilterOptions: {},
      requestTypeFilterOptions: [],
      requestActionFilterOptions,
      requestStatusFilterOptions,
      multipleReview: false,
      selectedRequestArray: [],
    };
  },
  methods: {
    openModal(data) {
      this.tempRow = data;
      this.isModalOpen = true;
    },
    cancelRequest() {
      const loader = this.$loading.show();

      const { id } = this.tempRow;
      this.$store
        .dispatch('cancelRoleRequest', {
          id,
        })
        .then((res) => {
          if (res) {
            this.$notify({
              group: 'primary',
              type: 'success',
              text: this.$t('request-successfully-cancelled'),
            });
          }
          this.getRequests();
          this.tempRow = null;
          this.isModalOpen = false;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setMultipleReview() {
      this.pageType = 'review';
      this.multipleReview = true;
    },
    searchDebounce() {
      const loader = this.$loading.show();
      this.page = 1;
      this.getRequests();
      loader.hide();
    },
    getRequests() {
      const loader = this.$loading.show();

      const { domain, typeFilter, statusFilter, actionFilter, search } = this;
      const page = this.page - 1;
      this.$store
        .dispatch('getRequests', {
          domain,
          typeFilter,
          statusFilter,
          actionFilter,
          search,
          page,
        })
        .then((res) => {
          this.requests = res.allRequests;
          this.totalCount = res.totalCount;
          this.getRequestReviews();
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getRequestReviews() {
      const loader = this.$loading.show();

      const { domain } = this;

      this.$store
        .dispatch('getRequestReviews', { domain })
        .then((res) => {
          this.reviewList = res.requestIdsArr;
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    getSingleRequest(id) {
      const loader = this.$loading.show();

      this.isModalOpen = false;

      this.$store
        .dispatch('getSingleRequest', {
          id,
        })
        .then((res) => {
          this.setSingleRequest(res.data.singleRequest);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setSingleRequest(request) {
      let counter = 0;

      request.forEach((subRequest) => {
        const tempObject = {
          domainName: subRequest.fullDomainName,
          requestedBy: subRequest.addedBy,
          requestDate: subRequest.createdAt,
          bcName: subRequest.fullBCName,
          requestNumber: (counter += 1),
        };
        Object.assign(subRequest, tempObject);
      });

      this.selectedRequestArray.push(...request);
      this.selectPageType();
    },
    selectPageType() {
      if (this.selectedRequestArray[0].canReview) {
        this.pageType = 'review';
      } else {
        this.pageType = 'edit';
      }
    },
    clearRequest() {
      const loader = this.$loading.show();
      this.pageType = null;
      this.request = null;
      this.multipleReview = false;
      this.reviewList = null;
      this.selectedRequestArray = [];
      this.getRequests();
      loader.hide();
    },
    goToPrograms() {
      this.$store.state.global.programName = null;
      this.$store.state.global.programImage = null;
      this.$router.push({
        name: 'Programs',
      });
      this.$store.state.activeNavTab = this.activeNavBar[0];
    },
    goToDealersList() {
      this.$router.push({
        name: 'Dealer-List',
      });
      this.$store.state.activeNavTab = this.activeNavBar[1];
    },
    getFilters() {
      const TypeFilters = this.requestTypeFilterOptions;
      const ActionFilters = this.requestActionFilterOptions;
      const StatusFilters = this.requestStatusFilterOptions;

      if (this.selectedLanguage.code === 'fr') {
        this.multiFilterOptions = {
          Taper: TypeFilters,
          Action: ActionFilters,
          Statut: StatusFilters,
        };
      } else {
        this.multiFilterOptions = {
          Type: TypeFilters,
          Action: ActionFilters,
          Status: StatusFilters,
        };
      }
      this.createFilters();
    },
    createFilters() {
      this.typeFilter = [];
      this.actionFilter = [];
      this.statusFilter = [];

      this.$store.state.activeSecurityCenterFilters = this.multiFilterOptions;
      this.setAppliedFilters();
    },
    setAppliedFilters() {
      this.typeFilter = [];
      this.actionFilter = [];
      this.statusFilter = [];

      const { typeFilter, actionFilter, statusFilter } = this;

      let length = 0;
      if (this.activeFilters) {
        if (this.selectedLanguage.code === 'fr') {
          if (this.activeFilters.Taper) {
            this.activeFilters.Taper.forEach((option) => {
              if (option.checked) typeFilter.push(option.label);
            });
          }
          if (this.activeFilters.Action) {
            this.activeFilters.Action.forEach((option) => {
              if (option.checked) actionFilter.push(option.label);
            });
          }
          if (this.activeFilters.Statut) {
            this.activeFilters.Statut.forEach((option) => {
              if (option.checked) statusFilter.push(option.label);
            });
          }
        } else {
          if (this.activeFilters.Type) {
            this.activeFilters.Type.forEach((option) => {
              if (option.checked) typeFilter.push(option.label);
            });
          }
          if (this.activeFilters.Action) {
            this.activeFilters.Action.forEach((option) => {
              if (option.checked) actionFilter.push(option.label);
            });
          }
          if (this.activeFilters.Status) {
            this.activeFilters.Status.forEach((option) => {
              if (option.checked) statusFilter.push(option.label);
            });
          }
        }
      }
      length = statusFilter.length + actionFilter.length + typeFilter.length;
      this.appliedFilters = {
        statusFilter,
        actionFilter,
        typeFilter,
        length,
      };
    },
    updateMulti(updates) {
      const loader = this.$loading.show();
      this.page = 1;
      this.multiFilterOptions = updates;
      this.$store.state.activeSecurityCenterFilters = this.multiFilterOptions;
      this.setAppliedFilters();
      this.getRequests();
      loader.hide();
    },
    clearAllFilters() {
      if (this.selectedLanguage.code === 'fr') {
        if (this.multiFilterOptions.Statut) {
          this.multiFilterOptions.Statut.forEach((tag) => {
            this.$set(tag, 'checked', false);
          });
        }
        if (this.multiFilterOptions.Action) {
          this.multiFilterOptions.Action.forEach((tag) => {
            this.$set(tag, 'checked', false);
          });
        }
        if (this.multiFilterOptions.Taper) {
          this.multiFilterOptions.Taper.forEach((tag) => {
            this.$set(tag, 'checked', false);
          });
        }
      } else {
        if (this.multiFilterOptions.Status) {
          this.multiFilterOptions.Status.forEach((tag) => {
            this.$set(tag, 'checked', false);
          });
        }
        if (this.multiFilterOptions.Action) {
          this.multiFilterOptions.Action.forEach((tag) => {
            this.$set(tag, 'checked', false);
          });
        }
        if (this.multiFilterOptions.Type) {
          this.multiFilterOptions.Type.forEach((tag) => {
            this.$set(tag, 'checked', false);
          });
        }
      }
      this.appliedFilters.length = 0;
      this.$store.state.activeSecurityCenterFilters = this.multiFilterOptions;
    },
    getTypeFilterOptions() {
      const loader = this.$loading.show();

      const { domain } = this;

      this.$store
        .dispatch('getRoleTypeFilterOptionsField', { domain })
        .then((res) => {
          this.setTypeFilterOptions(res.data.roleTypes);
        })
        .catch((error) => {
          if (error.data) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: error.data.error,
            });
          }
        })
        .finally(() => {
          loader.hide();
        });
    },
    setTypeFilterOptions(roles) {
      roles.forEach((role) => {
        const tempObj = { checked: false };
        tempObj.label = role;
        this.requestTypeFilterOptions.push(tempObj);
      });
    },
  },
  computed: {
    ...mapState('global', ['programName', 'programStyle']),
    ...mapState(['activeNavBar', 'activeNavTab']),
    ...mapState({
      domain: (state) => state.global.programName,
      activeFilters: 'activeSecurityCenterFilters',
    }),
    pageCount() {
      if (this.requests) {
        const l = this.totalCount;
        const s = this.rowCountDropValue.value;
        return Math.ceil(l / s);
      }
      return null;
    },
    firstRow() {
      if (this.requests.length > 0) {
        return (this.page - 1) * 10 + 1;
      }
      return 0;
    },
    lastRow() {
      return (this.page - 1) * 10 + this.requests.length;
    },
    showViewPage() {
      if (this.pageType === 'edit' && this.selectedRequestArray[0].canView) {
        return true;
      }
      return false;
    },
    selectedLanguage() {
      return this.$store.state.languages.selectedLanguage;
    },
  },
  created() {
    this.getRequests();
    this.getFilters();
    this.getTypeFilterOptions();
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  .title {
    font-size: 32px;
    font-weight: 100;
    text-transform: uppercase;
  }
  .subtitle {
    font-size: 14px;
    margin-top: 5px;
    list-style-type: none;
    margin-bottom: 0px;
    padding-left: 0px;
    li {
      cursor: pointer;
    }
    li:last-child {
      cursor: default;
      font-weight: bold;
    }
  }
  button:hover {
    text-decoration: underline;
  }
}
.content {
  height: 100%;
  flex-wrap: wrap;
  p {
    font-size: 18px;
    color: $primary-black;
  }
  .sub-title {
    text-align: left;
    font-size: 24px;
    margin-bottom: 10px;
  }
  .flexRow {
    display: flex;
    margin-top: 20px;
    input {
      margin-left: 20px;
    }
  }
  .flex-column {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  .small-title {
    color: black;
    font-size: 20px;
    margin-right: 20px;
  }
  .setup-row-1 {
    margin: 15px 0px 20px 0px;
  }
  .multiselect {
    margin-right: 15px;
  }
  .button-container {
    margin: 40px 0;
    button {
      margin-right: 20px;
    }
  }
  ul {
    list-style-type: none;
    li {
      margin-left: 0;
    }
  }
}
.above-table {
  padding: 0px 57px 0px 49px;
  margin-top: 34px;
}
.title-container {
  text-align: left;
  border-bottom: 1px #dfe4e8 solid;
  padding-left: 40px;
  padding-bottom: 25px;
  padding: 35px 30px 30px;
  justify-content: space-between;
  .right {
    display: flex;
    .search-input {
      width: 243px;
    }
  }
  .subtitle {
    li {
      color: #243882;
    }
  }
}
.table-descriptors {
  justify-content: space-between;
  font-size: 24px;
  align-items: center;
  .right {
    display: flex;
    input {
      margin-right: 20px;
    }
  }
}
.table-container {
  margin-top: 24px;
  .empty-table-message {
    display: flex;
    justify-content: center;
    margin: 40px 400px;
    span {
      font-size: 24px;
    }
    .attention {
      text-decoration: underline;
      cursor: pointer;
      margin-left: 3px;
      font-weight: bold;
    }
  }
}
.submit-request-container {
  margin-left: 50px;
  text-align: left;
  span {
    font-size: 24px;
  }
  .multiselect {
    margin-top: 25px;
  }
  .user-details {
    input {
      width: 300px;
      margin-bottom: 20px;
    }
  }
  .current-roles {
    border-left: 2px solid $fca-gray;
  }
  .action-container {
    .input-box {
      width: 50%;
      margin-top: 30px;
    }
  }
}
.requests-attention {
  padding: 5px 0;
  background-color: #c91919;
  color: $primary-white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  .attention {
    text-decoration: underline;
    cursor: pointer;
    margin-left: 3px;
    font-weight: bold;
  }
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.modal-button-container {
  display: flex;
  margin-top: 10px;
  justify-content: center;
  .submit {
    margin-right: 20px;
  }
}
.modal-body {
  display: flex;
  flex-direction: column;
  text-align: center;
  span {
    font-size: 24px;
  }
  .close {
    display: flex;
    justify-content: flex-end;
    svg {
      height: 30px;
      width: 30px;
      cursor: pointer;
    }
  }
  #modal-title {
    font-size: 21px;
  }
  #modal-message {
    font-size: 16px;
    color: $primary-black;
  }
  .request-details {
    color: $primary-black;
    display: flex;
    justify-content: center;
    ul {
      list-style-type: none;
      li {
        text-align: left;
      }
      span {
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
}
</style>
